import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import Image from 'next/image';
import { nextImageTransitionProps } from '@/constants/next-image-transition-props';
import { TheoryProps } from '@/types/theories';
import { urlFor } from '@/utils/buildImageSource';

const MainDiv = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 100px;
  padding: 20px 20px 80px 20px;
  justify-content: space-between;
`;
const TheoryTitle = styled(Typography)`
  font-family: var(--font-cooper-light), sans-serif;
  font-weight: 300;
  font-size: 40px;
  line-height: 112.3%;
  text-align: start;
  color: #231727;
  width: 100%;
  margin-bottom: 50px;
  margin-top: 100px;
`;
const DetailedTheoryTitle = styled(Typography)`
  font-family: var(--font-cooper-light);
  font-style: normal;
  font-weight: 300;
  font-size: 32px;
  line-height: 109.3%;
  color: #231727;
  margin-bottom: 20px;
  margin-top: 20px;
`;
const TheoryText = styled(Typography)`
  font-size: 16px;
  font-family: var(--font-work-sans), sans-serif;
  line-height: 159.3%;
  color: #231727;
  text-align: start;
  width: 100%;
`;
const TheoryDiv = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: auto;
  z-index: 1;
  margin-bottom: 32px;
`;

const MobileView = ({ theories }: TheoryProps) => {
  return (
    <MainDiv>
      <TheoryTitle>Acting at three levels</TheoryTitle>
      {theories.map((m, index) => (
        <TheoryDiv key={index}>
          <Image {...nextImageTransitionProps} src={urlFor(m.image)} alt="" />
          <DetailedTheoryTitle>{m.name}</DetailedTheoryTitle>
          <TheoryText>{m.detail}</TheoryText>
        </TheoryDiv>
      ))}
    </MainDiv>
  );
};

export default MobileView;
